module.exports = __webpack_public_path__ + "img/yz.32083a73.png";